import * as yup from 'yup';
import { TFunction } from 'i18next';
import {
  CreateReinsuredPayloadDto,
  CreateReinsuredPayloadDtoStatusEnum,
} from 'libs/pinnacle-sdk';

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    status: yup
      .string()
      .required(t('validation.required', { field: t('general.status') })),
    reinsuredGroup: yup
      .string()
      .required(
        t('validation.required', { field: t('reinsured.reinsuredGroup') })
      ),
    legalEntityName: yup
      .string()
      .trim()
      .required(
        t('validation.required', { field: t('reinsured.legalEntityName') })
      ),
    name: yup
      .string()
      .trim()
      .required(
        t('validation.required', { field: t('reinsured.reinsuredName') })
      ),
    country: yup
      .string()
      .required(t('validation.required', { field: t('general.country') })),
    city: yup.string(),
    postcode: yup.string().max(
      10,
      t('validation.maxLength', {
        field: t('general.postcode'),
        length: 10,
      })
    ),
    address: yup.string(),
    comment: yup.string(),
  });

export const initialValues = {
  status: CreateReinsuredPayloadDtoStatusEnum.Active,
  reinsuredGroup: undefined,
  legalEntityName: undefined,
  name: undefined,
  address: undefined,
  country: undefined,
  city: undefined,
  postcode: undefined,
  comment: undefined,
  state: undefined,
};

export const fields = Object.keys(
  initialValues
) as (keyof CreateReinsuredPayloadDto)[];
